var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkillsDePr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E040FB;}\n\t.st1{fill:#020F16;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6,58C6,29.3,29.3,6,58,6h364c28.7,0,52,23.3,52,52v364c0,28.7-23.3,52-52,52H58c-28.7,0-52-23.3-52-52V58z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45,45v390h390V45H45z M201.2,177.3h-26v57.6h25.6c7.1,0,12.6-2.3,16.5-7c3.9-4.7,5.8-11.4,5.8-20.3 c0-9.2-2-16.6-6-22C213.2,180.1,207.9,177.4,201.2,177.3z M244.7,250.3C234,260.8,219.1,266,200.1,266h-24.9v65H136V146.2h64.8 c18.3,0,32.9,5.7,43.7,17c10.9,11.3,16.3,26.1,16.3,44.2S255.5,239.8,244.7,250.3z M359.6,228.3l-11.7-1.3c-10.4,0-16.9,3.9-19.5,13 v91H292V193.2h33.8l1.3,14.3c5.2-11.7,13-16.9,23.4-16.9c3.9,0,7.8,0,10.4,1.3L359.6,228.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsDePr);
export default __webpack_public_path__ + "static/media/skills-de_pr.c1f7ab038de86f7ef588d8792d35d245.svg";
export { ForwardRef as ReactComponent };